import { useSpatial } from "./SpatialContext";
import BulletinNotes from "./BulletinNotes";

export default function BulletinPanel({ onClose }) {
  const { surfaceState } = useSpatial();
  const bulletinItems = surfaceState?.bulletinItems || [];
  const isEmpty = bulletinItems.length === 0;
  const doneCount = bulletinItems.filter(i => i.done).length;

  return (
    <div className="flex flex-col h-full font-['DM_Sans'] overflow-hidden rounded-2xl"
      style={{ background: "linear-gradient(135deg, #C4956A 0%, #A67C52 40%, #B8865E 70%, #C4956A 100%)" }}>

      <div className="absolute inset-0 pointer-events-none rounded-2xl" style={{
        backgroundImage: `radial-gradient(ellipse at 20% 30%, rgba(255,255,255,0.06) 0%, transparent 50%),
          radial-gradient(ellipse at 80% 70%, rgba(0,0,0,0.08) 0%, transparent 50%),
          repeating-linear-gradient(45deg, transparent, transparent 2px, rgba(0,0,0,0.03) 2px, rgba(0,0,0,0.03) 4px)`,
        zIndex: 0,
      }} />

      <div className="flex items-center justify-between flex-shrink-0 relative"
        style={{
          zIndex: 1,
          padding: "10px 16px",
          background: "rgba(0,0,0,0.2)",
          backdropFilter: "blur(8px)",
          borderBottom: "1px solid rgba(255,255,255,0.1)",
        }}>
        <div className="flex items-center gap-[10px]">
          <span style={{ fontSize: 15 }}>📌</span>
          <span style={{ fontSize: 17, fontWeight: 700, color: "rgba(255,255,255,0.95)" }}>Bulletin Board</span>
          {!isEmpty && (
            <span style={{ fontSize: 11, color: "rgba(255,255,255,0.5)" }}>
              {doneCount}/{bulletinItems.length} done
            </span>
          )}
        </div>
        <button
          onClick={onClose}
          style={{
            background: "transparent", border: "none",
            color: "rgba(255,255,255,0.5)", fontSize: 16,
            cursor: "pointer", padding: "2px 6px",
          }}
        >
          ✕
        </button>
      </div>

      <div className="flex-1 overflow-y-auto relative" style={{ zIndex: 1, padding: "28px 24px 20px" }}>
        <BulletinNotes />
      </div>

      <div className="flex-shrink-0 relative" style={{
        zIndex: 1,
        padding: "10px 16px",
        background: "rgba(0,0,0,0.2)",
        backdropFilter: "blur(8px)",
        borderTop: "1px solid rgba(255,255,255,0.1)",
      }}>
        <div style={{ fontSize: 11, color: "rgba(255,255,255,0.45)", fontStyle: "italic" }}>
          ✦ Click a note to edit it, or ask Lumen to add one
        </div>
      </div>
    </div>
  );
}
